import { TimePeriod } from '@alberta/konexi-shared';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { returnDurationText } from 'src/app/business/general/duration2text-factory';

@Pipe({
  name: 'timePeriodPipe',
  pure: false,
  standalone: false,
})
export class TimePeriodPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}
  transform(timePeriod: TimePeriod, plural: boolean = false, dative: boolean = false): any {
    return returnDurationText(this._translate, +timePeriod, plural, dative);
  }
}

@Pipe({
  name: 'timePeriodAdjectivePipe',
  pure: false,
  standalone: false,
})
export class TimePeriodAdjectivePipe implements PipeTransform {
  constructor(private _translate: TranslateService) {}
  transform(timePeriod: TimePeriod): any {
    return returnDurationText(this._translate, +timePeriod, false, false, true);
  }
}
